export default __webpack_public_path__ + "static/media/solace-circle-white.faf30061.svg";